import { NervaProductAddons } from 'hydra-data-types';

// const nervaIBSExpertsExperimentMapping = {
// 	'Control': undefined,
// 	'AddonPrice47WithScreen': NervaProductAddons.NervaAddonIBSExpertsQA47Price,
// 	'AddonPrice97WithScreen': NervaProductAddons.NervaAddonIBSExpertsQA97Price,
// 	'AddonPrice47NoScreen': NervaProductAddons.NervaAddonIBSExpertsQA47Price,
// 	'AddonPrice97NoScreen': NervaProductAddons.NervaAddonIBSExpertsQA97Price,
// };

/**
 * Get the addon plan for the IBS Experts experiment.
 * This is used to determine the price of the addon.
 */
export function chooseAddonPlanPerExperiment(): NervaProductAddons | undefined {
  // TODO: Uncomment this when an addon is available for purchase
  // const { NervaIBSExpertsAddon } = AllExperiments;
  // const experimentVariant = NervaIBSExpertsAddon.select(nervaIBSExpertsExperimentMapping);

  // return experimentVariant;
  return undefined;
}
